import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, required_if, email, regex, numeric, length, confirmed } from 'vee-validate/dist/rules';
import { configure } from 'vee-validate';
import { localize } from 'vee-validate';
import dictionnaryFr from './vv-dictionary-fr';

localize('fr', dictionnaryFr);

extend('email', email);
extend('required', required);
extend('required_if', required_if);
extend('regex', regex);
extend('numeric', numeric);
extend('length', length);
extend('confirmed', confirmed);

configure({
  classes: {
    invalid: 'error',
  }
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
